
export function getCustomExpression(exp) {
    return 'matchRegexp:^[a-zA-Z0-9-'+ exp +']+$';
}

export function getCustomExpressionLength(exp, minlength, maxlength) {
    return 'matchRegexp:^[a-zA-Z0-9-'+ exp +']{'+ minlength +','+ maxlength +'}$';
}

export function getCustomExpMessage(exp) {
    return 'Allowed special characters are '+ exp;
}

export function getCustomLengthMessage(maxlength) {
    return 'Maximum length should not exceed'+ maxlength +'characters';
}



let exp = '_,!@$%&:;(){}/.?" ';
let multiLineExp = '_,!@$%&:;(){}/.?"\n\r ';
let multiLineMsg = '_,!@$%&:;(){}/.?" ';

let maxLength = '100';
let minLength = '8';
let maxMultiLine = '1000';

export let regexMinLength = 'matchRegexp:^.{'+ minLength +',1000}$';
export let messageMinLength='Minimum password length should be '+ minLength;

export let regexAlphaNumeric = 'matchRegexp:^[\u0660-\u0669\u0621-\u064Aa-zA-Z0-9-_. ]+$';
export let regexAlphaNumericLength = 'matchRegexp:^[\u0660-\u0669\u0621-\u064Aa-zA-Z0-9-_. ]{0,'+ maxLength +'}$';


export let regexUserName = 'matchRegexp:^[a-zA-Z0-9-_.]+$';
export let regexUserNameLength = 'matchRegexp:^[a-zA-Z0-9-_.]{0,'+ maxLength +'}$';
export let regexExpEng = 'matchRegexp:^[Aa-zA-Z0-9-'+ exp +']+$';
export let regexExpEngLength = 'matchRegexp:^([Aa-zA-Z0-9-'+ exp +']){0,'+ maxLength +'}$';

export let regexExp = 'matchRegexp:^[\u0660-\u0669\u0621-\u064Aa-zA-Z0-9-'+ exp +']+$';
export let regexExpLength = 'matchRegexp:^([\u0660-\u0669\u0621-\u064Aa-zA-Z0-9-'+ exp +']){0,'+ maxLength +'}$';
export let regexExpNum = 'matchRegexp:^[0-9]+$';


export let messageNumeric = 'Only Numeric values are allowed'; 
export let messageAlphaNumeric = 'Only Alpha Numeric values are allowed'; 
export let messageRegexEng = 'Only English and allowed special charecters are'+ exp; 
export let messageRegexEx='Allowed special characters are '+ exp;
export let messageLength = 'Maximum length should not exceed '+ maxLength +' characters';



export let regexMultiLineExp = 'matchRegexp:^[\u0660-\u0669\u0621-\u064Aa-zA-Z0-9-'+ multiLineExp +']+$';
export let regexMultiLineExpLength = 'matchRegexp:^([\u0660-\u0669\u0621-\u064Aa-zA-Z0-9-'+ multiLineExp +']){0,'+ maxMultiLine +'}$';

export let messageMultilineRegexEx='Allowed special characters are '+ multiLineMsg;
export let messageMultilineLength = 'Maximum length should not exceed '+ maxMultiLine +' characters';


// WEBPACK FOOTER //
// ../appConstants.js